import React, { useEffect, useState } from "react";
import "./Common_Title.css";
import { getData } from "../../../utils/api";
function Common_Title({ title }) {
  const [packages, setPackage] = useState([]);

  const getPackageAll = async () => {
    const response = await getData(`/master/cruise-package/`);

    setPackage(response?.data);
  };

  useEffect(() => {
    getPackageAll();
  }, []);

  return (
    <div className="title">
      <h5 className="Heading">{title}</h5>
    </div>
  );
}

export default Common_Title;
